import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Depr: Topic Present",
  order: 500,
};
